import { vhtSegments } from '../config/megaUseCases';

export const getVhtSegment = (megaUseCase: string, productCode: string) => {
  return productCode && vhtSegments[productCode][megaUseCase];
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/VhtUtil.ts